module.exports = __webpack_public_path__ + "img/SH.97cf2d0b.svg";